import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface IssueWiseIssueCountState {
    IssueWiseIssueCount: {
        load: boolean;
        data: [];
    };
}

export const IssueWiseIssueCountSlice = createSlice({
    name: "IssueWiseIssueCount",
    initialState: {
        IssueWiseIssueCount: {
            load: false,
            data: [],
        },
    } as IssueWiseIssueCountState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            .addCase(fetchIssueWiseCount.pending, (state: IssueWiseIssueCountState) => {
                state.IssueWiseIssueCount.load = true;
            })
            .addCase(fetchIssueWiseCount.fulfilled, (state: IssueWiseIssueCountState, action: any) => {
                state.IssueWiseIssueCount.data = action.payload;
                state.IssueWiseIssueCount.load = false;
            })
            .addCase(fetchIssueWiseCount.rejected, (state: IssueWiseIssueCountState) => {
                state.IssueWiseIssueCount.load = false;
            });
    },
});

export default IssueWiseIssueCountSlice.reducer;

export const fetchIssueWiseCount = createAsyncThunk(
    "IssueWiseIssueCount/fetchIssueWiseCount",
    async (param: { apiParam: { project_pin: any, layout_id: any } }, thunkAPI) => {
        try {
            const { data } = await DataServer.post("api/getIssueWiseCount", {
                project_pin: param.apiParam.project_pin,
                layout_id: param.apiParam.layout_id
            });
            return data.data;
        } catch (error) {
        }
    }
);